__webpack_require__.p = "https://assets.production.decovostatic.com/next-static-live/pantryshop-frontend-v2/_next/";